import { isAvailable } from '@setapp/desktop-app-helper';
import BasePage from '../../components/base-page/base-page';
import defineAppWidgetElement from '../../components/app-widget/app-widget';
import definePromoAppsCollectionElement from '../../components/promo-apps-collection/promo-apps-collection';

import './app-article-web.scss';


class AppArticleWeb extends BasePage {
  onInit() {
    super.onInit();

    isAvailable({
      onSuccess: () => {
        window.location.assign(`setappdiscovery://open_blog_article?blog_article_url=${window.location.href}`);
      },
    });

    defineAppWidgetElement();
    definePromoAppsCollectionElement();
  }
}

export default AppArticleWeb;

(AppArticleWeb as BasePage).initOnDomLoaded();
